import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewPlanEditContainer } from "@/components/features/items/edit/plan/standard-plan/default/ui/new/container";

import { useGetNewPlanEditPageParams } from "./_hooks/use-get-new-plan-edit-page-params";

export const NewPlanEditPageDefault = () => {
	const { hotelID, duplicateItemID } = useGetNewPlanEditPageParams();
	const activeLangCode = LangCode.Default;

	return (
		<PageMeta title="プランの作成" url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.NEW.PLAN.STANDARD, { hotelID })}>
			<NewPlanEditContainer hotelID={hotelID} planID={duplicateItemID} activeLangCode={activeLangCode} />
		</PageMeta>
	);
};

NewPlanEditPageDefault.displayName = "NewPlanEditPageDefault";
